/* eslint-disable */
export default {
  attachFiles: 'Joindre un fichier',
};

// @key: @#@"attachFiles"@#@ @source: @#@"Attach file"@#@
